export type StockFilterStored = {
    vendors: string[];
    showAll: boolean;
    categoryIds: number[];
};

const normalizeCategoryIds = (row: Record<string, unknown>): number[] => {
    const raw = Array.isArray(row.categoryIds)
        ? row.categoryIds
        : row.categoryId != null && `${row.categoryId}` !== ''
          ? [row.categoryId]
          : [];
    const ids = raw
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0);
    return Array.from(new Set(ids));
};

const storageKey = (userId: number): string => `voltox-${userId}-warehouse-stock-filter`;

const normalizeFilter = (value: unknown): StockFilterStored | null => {
    if (!value || typeof value !== 'object') return null;
    const row = value as Record<string, unknown>;
    const vendors = Array.isArray(row.vendors)
        ? row.vendors.map(String).filter(Boolean)
        : [];
    const showAll = Boolean(row.showAll);
    const categoryIds = normalizeCategoryIds(row);
    if (!vendors.length && !showAll && !categoryIds.length) return null;
    return { vendors, showAll, categoryIds };
};

export const loadStockFilter = (userId: number): StockFilterStored | null => {
    if (!userId || typeof window === 'undefined') return null;
    try {
        const raw = window.localStorage.getItem(storageKey(userId));
        if (!raw) return null;
        return normalizeFilter(JSON.parse(raw));
    } catch {
        return null;
    }
};

export const saveStockFilter = (
    userId: number,
    filter: Record<string, unknown> | null | undefined,
): void => {
    if (!userId || typeof window === 'undefined') return;
    try {
        const normalized = normalizeFilter(filter);
        if (!normalized) {
            window.localStorage.removeItem(storageKey(userId));
            return;
        }
        window.localStorage.setItem(storageKey(userId), JSON.stringify(normalized));
    } catch {
        /* ignore quota / private mode */
    }
};
